export const GET_HEADER_MENUS = "GET_HEADER_MENUS";

export const getWPmenus = () => {
	return {
		type: "GET_HEADER_MENUS",
	};
};

export const putWPMenus = (menus = []) => {
	return {
		type: "PUT_HEADER_MENUS",
		payload: {
			menus,
		},
	};
};



// WEBPACK FOOTER //
// ./src/actions/header.js